/* eslint-disable prefer-rest-params */
/**
 * Vanilla JavaScript replacement of $.extend
 * http: //youmightnotneedjquery.com/#deep_extend
 * Small modifications done by us (fixing ESLint errors)
 */

/**
 * jQuery.extend(true, {}, obj) alternative (recursive)
 * @deprecated Use Object.assign or the spread operator instead
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function deepExtend(out: object, ...args: unknown[]) {
  function checkType(item: unknown[] | object, result: object): unknown {
    // Note: no use of instanceof so it continues working in our iframe: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray#instanceof_vs_isarray
    if (Array.isArray(item)) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      return item.map((subItem) => checkType(subItem, {}));
    }

    if (typeof item === 'object') {
      return deepExtend(result, item);
    }

    return item;
  }

  const result = (out || {}) as Record<string, unknown>;

  for (let i = 0; i < args.length; i++) {
    const obj = args[i];

    if (obj) {
      Object.entries(obj).forEach(([key, value]) => {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          result[key] = checkType(value, result[key] as object);
        }
      });
    }
  }

  return result;
}

/**
 * jQuery.extend alternative
 * @deprecated Use Object.assign or the spread operator instead
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function extendObj(out: Record<string, unknown>) {
  const result = out || {};

  for (let i = 1; i < arguments.length; i++) {
    if (arguments[i]) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      Object.keys(arguments[i]).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          result[key] = arguments[i][key];
        }
      });
    }
  }

  return result;
}
